module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid card-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-desktop-side"
  }, [_c('desktop-sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "card-desktop-main"
  }, [_c('div', {
    staticClass: "card crd-header"
  }, [_c('desktop-header')], 1), _vm._v(" "), _c('div', {
    staticClass: "card card-desktop-body"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card crd-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('h2', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Orders")]), _vm._v(" "), ((Object.keys(_vm.orders).length > 0)) ? _c('div', _vm._l((_vm.orders), function(order) {
    return _c('div', {
      staticClass: "row card-box card-02",
      staticStyle: {
        "border-bottom": "#eee solid",
        "margin-bottom": "2em"
      }
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/placed/order/' + order.order_no
      }
    }, [_c('div', {
      staticClass: "col-xs-4"
    }, [_c('div', {
      staticStyle: {
        "display": "inline",
        "padding-bottom": "1em"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "80px",
        "height": "100px",
        "border-radius": "8px"
      },
      attrs: {
        "src": _vm.img_product_url + order.order_items[0].product_item_group_image
      }
    }), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('h4', {
      staticStyle: {
        "font-weight": "800"
      }
    }, [_vm._v(_vm._s(order.order_items[0].product_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(order.order_details))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(order.order_time_ago) + " >")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000",
      "text-align": "right"
    }
  }, [_vm._v("No Orders yet")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "3em",
      "border": "#666 solid 1px",
      "background": "#0d0e00",
      "color": "#ffffff",
      "border-radius": "15px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none",
      "padding": "0.2em 0.5em",
      "line-height": "0.2",
      "margin-top": "-2em",
      "margin-left": "1.2em",
      "margin-bottom": "1em",
      "background": "#ffe600",
      "border-radius": "7px",
      "color": "#0d0e00",
      "width": "55%"
    }
  }, [_c('h4', {
    staticClass: "ctro",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('u', [_vm._v("Activities Today")])])]), _vm._v(" "), _c('div', {
    staticClass: "cblackboard"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Total Orders     - - - - - - - - - - - - - - - - -")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("123")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Orders Placed     - - - - - - - - - - - - - - - - -")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("123")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Items on Sale     - - - - - - - - - - - - - - - - -")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("123")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "0.1em 0.5em",
      "line-height": "0.2",
      "margin-top": "-1em",
      "margin-left": "35%",
      "margin-bottom": "0.2em",
      "background": "#fdfce8",
      "border-radius": "7px",
      "color": "#0d0e00",
      "width": "55%"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" Add new order")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticStyle: {
      "margin-left": "1.52em"
    }
  }, [_vm._v("Manage your Business / Shop  "), _c('i', {
    staticClass: "fas fa-angle-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6 card-col"
  }, [_c('div', {
    staticClass: "card-box-col card-box-col-active"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fas fas fa-pencil-alt"
  }), _vm._v("__")]), _vm._v(" "), _c('p', [_vm._v("Manage Items you sell Add / Remove")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 card-col"
  }, [_c('div', {
    staticClass: "card-box-col"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fas fas fa-pencil-alt"
  }), _vm._v("__")]), _vm._v(" "), _c('p', [_vm._v("Checkout and manage Placed Orders")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 card-col"
  }, [_c('div', {
    staticClass: "card-box-col"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fas fas fa-pencil-alt"
  }), _vm._v("__")]), _vm._v(" "), _c('p', [_vm._v("Show only today's menu, not all Items")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 card-col"
  }, [_c('div', {
    staticClass: "card-box-col"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fas fas fa-pencil-alt"
  }), _vm._v("__")]), _vm._v(" "), _c('p', [_vm._v("Store Settings"), _c('br'), _c('span', [_vm._v("edit name and details")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "#ff0000",
      "font-weight": "600"
    }
  }), _vm._v(" Re-Order")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bccff2c4"}!./src/pages/dashboard/desktop/desktop.html
// module id = 620
// module chunks = 0